import {
  Button,
  Cascader,
  DatePicker,
  Flex,
  Form,
  Input,
  InputNumber,
  Radio,
  Select,
  Switch,
  TreeSelect,
  Typography,
} from "antd";
import * as React from "react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
const { Title, Text } = Typography;

const TextInsertion = ({ insertFormValues }) => {
  const [text, setText] = useState("");

  const { t } = useTranslation();
  const taskTypes = [
    {
      label: t("Form_#Offer"),
      value: t("Form_#Offer"),
    },
    {
      label: t("Form_#Fix"),
      value: t("Form_#Fix"),
    },
    {
      label: t("Form_#Implement"),
      value: t("Form_#Implement"),
    },
  ];
  const urgencyTypes = [
    {
      label: <Text type="success">{t("Form_#Low")}</Text>,
      value: t("Form_#Low"),
    },
    {
      label: <Text type="warning">{t("Form_#Medium")}</Text>,
      value: t("Form_#Medium"),
    },
    {
      label: <Text type="danger">{t("Form_#High")}</Text>,
      value: t("Form_#High"),
    },
  ];

  const handleTextInsertion = async (values) => {
    values.task_deadline = values.task_deadline.format("DD.MM.YYYY");
    await insertFormValues({ values, t });
  };

  return (
    <div style={{ margin: "0", padding: "15px" }}>
      <Form onFinish={(e) => handleTextInsertion(e)}>
        <Form.Item label={<Title level={5}>{t("Form_#Task Description")}</Title>} name="task_description">
          <Input.TextArea
            rows={10}
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder={t(
              "Form_#Provide a clear and concise description of the problem or task that needs to be addressed."
            )}
          />
        </Form.Item>
        <Form.Item label={<Title level={5}>{t("Form_#Task Type")}</Title>} name="task_type">
          <Flex vertical gap="middle">
            <Radio.Group block options={taskTypes} />
          </Flex>
        </Form.Item>
        <Form.Item label={<Title level={5}>{t("Form_#Deadline")}</Title>} name="task_deadline">
          <DatePicker
            style={{ width: "100%" }}
            placeholder={t("Form_#Select Date")}
            format="DD.MM.YYYY"
            locale={Office.context.displayLanguage.split("-")[0]}
          />
        </Form.Item>
        <Form.Item label={<Title level={5}>{t("Form_#Urgency")}</Title>} name="task_urgency">
          <Flex vertical gap="middle">
            <Radio.Group block options={urgencyTypes} />
          </Flex>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
            {t("Form_#Submit")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default TextInsertion;
